// src/stores/authStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthSession {
    id: string;
    device_uuid: string;
    role: string;
    expires_at: number;
}

interface AuthState {
    deviceUuid: string;
    session: AuthSession | null;
    initialize: () => void;
    setSession: (session: AuthSession | null) => void;
    logout: () => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set, get) => ({
            deviceUuid: '',
            session: null,

            initialize: () => {
                let uuid = get().deviceUuid;
                if (!uuid) {
                    uuid = crypto.randomUUID();
                    set({ deviceUuid: uuid });
                }
            },

            setSession: (session) => set({ session }),

            logout: () => set({ session: null })
        }),
        {
            name: 'naz_auth_storage',
        }
    )
);
